export default __webpack_public_path__ + "assets/ff80fef2623bff17aceffb30b8d1a6fa.svg";